// Copyright (c) 2023. Engie-Electrabel. All rights reserved.
//
// Engie-Electrabel n.v./s.a., Simon Bolivarlaan 34 Boulevard Simón Bolivar, BTW BE 0403.107.701 - 1000 Brussel/Bruxelles, Belgium.
//
// Proprietary Notice:
// This software is the confidential and proprietary information of Engie-Electrabel s.a./n.v. and/or its licensors.
// You shall not disclose this Confidential Information to any third parties and any use thereof shall be subject to the terms and conditions of use, as agreed upon with Engie-Electrabel in writing.
//
/// <reference types="vite/client" />
/// <reference types="element-plus/global" />
/// <reference types="@service-portal/commons/types" />
import { RouteNames } from '@/route-names'
import { UserRoles } from '@service-portal/commons'
import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/:pathMatch(.*)*',
    name: RouteNames.Error404,
    component: () => import('views/error/NotFound.vue')
  },
  {
    path: '/access-denied',
    name: RouteNames.ErrorAccessDenied,
    component: () => import('views/error/AccessDenied.vue')
  },
  {
    path: '/',
    name: RouteNames.Root,
    component: () => import('views/RootView.vue'),
    meta: {
      requiresAuth: true,
      title: '...'
    }
  },
  {
    path: '/profile',
    component: () => import('views/GenericRouterView.vue'),
    name: RouteNames.ProfilePanel,
    meta: {
      title: 'Profile',
      requiresAuth: true,
    },
    redirect: { name: RouteNames.ProfileRequestAccess },
    children: [
      {
        path: 'request-access',
        name: RouteNames.ProfileRequestAccess,
        component: () => import('views/ProfileRequestAccess.vue'),
        meta: {
          title: 'Request access',
          requiresAuth: true
        }
      }
    ]
  }
]
